import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=1054021b&scoped=true&"
import script from "./commentList.vue?vue&type=script&lang=js&"
export * from "./commentList.vue?vue&type=script&lang=js&"
import style0 from "./commentList.vue?vue&type=style&index=0&id=1054021b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054021b",
  null
  
)

export default component.exports